import { i18n } from '@/i18n/i18n'
import { regex } from 'vee-validate/dist/rules'

export const regexId = {
  ...regex,
  validate: (value, params) => {
    return regex.validate(value, params)
  }
}

export const versionHigher = {
  message () {
    return i18n.t('validation.versionHigher')
  },

  validate (value, [currentVersion]) {
    if (value === null || value === undefined || value === '') {
      return false
    }

    const valueArray = value.split('.')
    const currentVersionArray = currentVersion.split('.')

    if (parseInt(valueArray[0]) > parseInt(currentVersionArray[0])) {
      return true
    } else if (parseInt(valueArray[1]) > parseInt(currentVersionArray[1])) {
      return true
    } else if (parseInt(valueArray[2]) >= parseInt(currentVersionArray[2])) {
      return true
    }
  }
}

export const uniqueId = {
  message () {
    return i18n.t('validation.uniqueId')
  },

  validate (value, [document, mode]) {
    let count = 0
    count = this.searchIdInChildren(value, document, count)
    return mode === 'create' ? count < 1 : count < 2
  },

  searchIdInChildren (value, node, count) {
    if (node.id && node.id.toLowerCase() === value.toLowerCase()) {
      count++
    }
    if (node.children) {
      for (const child of node.children) {
        if (child.children) {
          count = this.searchIdInChildren(value, child, count)
        }
      }
    }
    return count
  }
}
